import FadeInSection from "../../ui/fade-in-section";

const USE_CASE_WHATSAPP_URL =
  "https://wa.me/918758379686?text=" +
  encodeURIComponent("Hi PyCray, I'd like to talk about a use case for my business");

export default function UseCasesCta() {
  return (
    <section className="bg-navy text-white">
      <FadeInSection y={20} duration={0.45}>
        <div className="page-container py-12 sm:py-16 lg:py-20 text-center px-4">
          <p className="text-base sm:text-xl text-white/90 font-medium leading-relaxed max-w-2xl mx-auto">
            All demos run on live AI. No signup required. No data stored.
          </p>

          <a
            href={USE_CASE_WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 sm:mt-8 inline-flex items-center justify-center gap-2 w-full sm:w-auto px-6 sm:px-8 py-3.5 rounded-[6px] bg-teal text-white font-semibold text-[15px] transition-all duration-200 hover:bg-[#11997A] hover:scale-[1.03] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal"
          >
            Talk to us about your use case
          </a>

          <p className="mt-10 text-[11px] sm:text-xs text-white/40 leading-relaxed">
            Powered by Claude · Enterprise deployment available · Built by PyCray
            Technologies
          </p>
        </div>
      </FadeInSection>
    </section>
  );
}
